






import CheckboxInput from '@/baklava/input/CheckboxInput.vue';
import { Prop, Vue, Component } from 'vue-property-decorator';
import CheckboxValue from '@/baklava/CheckboxValue';

@Component({
  components: { CheckboxInput },
})
export default class CheckboxField extends Vue {
  @Prop({ required: true }) label!: string;
  @Prop({ default: CheckboxValue.CHECKED }) checked?: CheckboxValue;

  private valueChange(newValue: CheckboxValue) {
    this.$emit('value-change', newValue);
  }
}
